import Vue from 'vue';
import moment from 'moment';
import Axios from 'axios';
import { logActivity } from '@/services/ActivityLogService';
export const KidSchoolModule = {
    namespaced: true,
    state: [],
    mutations: {
        setAll(state, kidSchools) {
            state.splice(0, state.length);
            state.push(...kidSchools);
        },
        store(state, kidSchool) {
            state.push(kidSchool);
        },
        update(state, kidSchool) {
            state.find((oldKidSchool, index) => {
                if (oldKidSchool.id === kidSchool.id) {
                    Vue.set(state, index, kidSchool);
                }
            });
        },
        destroy(state, id) {
            state.splice(state.findIndex(item => id === item.id), 1);
        },
        clear(state) {
            state.splice(0, state.length);
        },
    },
    actions: {
        async getAll(context) {
            try {
                const request = (await Axios.get(`api/detske-skolky/${process.env.VUE_APP_AREAL_ID}`));
                context.commit('setAll', request.data);
            }
            catch (e) {
                console.log(e);
            }
        },
        async getById(context, id) {
            try {
                const request = (await Axios.get(`api/detske-skolky/${process.env.VUE_APP_AREAL_ID}/${id}`));
                context.commit('update', request.data);
                return request.data;
            }
            catch (e) {
                console.log(e);
                context.commit('destroy', id);
                throw (e);
            }
        },
        async store(context, kidSchool) {
            try {
                const request = (await Axios.post(`api/detske-skolky/${process.env.VUE_APP_AREAL_ID}`, kidSchool));
                context.commit('store', request.data);
                logActivity('CREATE', 'kidSchool', String(request.data.id), null, request.data);
                await context.dispatch('instructorTable/refreshDate', { date: moment(kidSchool.dateTime) }, { root: true });
            }
            catch (e) {
                console.log(e);
            }
        },
        async update(context, kidSchool) {
            try {
                const previousValue = context.state.find((k) => k.id === kidSchool.id);
                const request = (await Axios.put(`api/detske-skolky/${process.env.VUE_APP_AREAL_ID}/${kidSchool.id}`, kidSchool));
                context.commit('update', request.data);
                logActivity('UPDATE', 'kidSchool', String(kidSchool.id), previousValue ? previousValue : null, request.data);
                await context.dispatch('instructorTable/refreshDate', { date: moment(kidSchool.dateTime) }, { root: true });
            }
            catch (e) {
                console.log(e);
            }
        },
        async destroy(context, id) {
            const previousValue = context.state.find((k) => k.id === id);
            await Axios.delete(`api/detske-skolky/${process.env.VUE_APP_AREAL_ID}/${id}`);
            context.commit('destroy', id);
            logActivity('DELETE', 'kidSchool', String(id), previousValue ? previousValue : null, null);
        },
    },
    getters: {
        all(state) {
            return state;
        },
        find(state) {
            return (date) => {
                return state.filter(x => moment(x.dateTime).isSame(date, "date"));
            };
        },
    }
};
